import { NextBillionMarker } from '../models/response/appointment/roadshow-timeslot-main-response-model';

export interface MarkerAssets {
  img:     string;
  name:    string;
  address: string;
  width:   number;
  height:  number;
}

export function resolveMarkerAssets(point: NextBillionMarker, index: number): MarkerAssets {
  let img = '', name = '', address = '', width = 48, height = 48;
  if (!point.isForTherapistModule) {
    if (point.originatedFromTherapist && index === 0) {
      img = 'therapist-location.png'; name = 'Therapist'; address = point.therapistAddress; width = 24; height = 37;
    } else if (!point.originatedFromTherapist && index === 0) {
      img = 'start-location-icon.svg'; name = point.patientName; address = point.patientAddress; width = 72; height = 72;
    } else if (point.isEndLocation) {
      img = 'end-location-icon.svg'; name = point.patientName; address = point.patientAddress; width = 72; height = 72;
    } else if (point.isTargetPatient) {
      img = 'current-patient-location.png'; name = point.patientName; address = point.patientAddress; width = 24; height = 37;
    }
  } else {
    if (point.originatedFromTherapist) {
      img = 'therapist-location.png'; name = point.patientName; address = point.patientAddress; width = 24; height = 37;
    } else if (!point.isTargetPatient && !point.isEndLocation && !point.isPatientMarker) {
      img = 'start-location-icon.svg'; name = point.patientName; address = point.patientAddress; width = 72;
    } else if (point.isTargetPatient) {
      img = 'current-patient-location.png'; name = point.patientName; address = point.patientAddress; width = 24; height = 37;
    } else if (point.isEndLocation) {
      img = 'end-location-icon.svg'; name = point.patientName; address = point.patientAddress; width = 72;
    } else if (point.isPatientMarker) {
      img = 'patient-location.png'; name = point.patientName; address = point.patientAddress; width = 24; height = 37;
    }
  }

  return { img, name, address, width, height };
}